<template>
    <div class="row no-gutters vh-100-navbarless pl-transition disable-selection" :style="'padding-left: ' + $store.getters.getContentPadding">
        <div class="main col-12 col-lg-7  h-inherit overflow-auto">
            <div class="chapter-list">
                <ChapterEntryListInReadOnlyMode :chapters="chapters" v-if="$store.getters.chapterEntryMode === 'default' && $store.getters.instanceInReadOnly"></ChapterEntryListInReadOnlyMode>
                <DefaultChapterEntryList :chapters="chapters" v-else-if="$store.getters.chapterEntryMode === 'default'"></DefaultChapterEntryList>
                <ChapterEntryListInMoveMode :chapters="chapters" v-else-if="$store.getters.chapterEntryMode === 'move'"></ChapterEntryListInMoveMode>
                <ChapterEntryListInTimeShiftMode :chapters="chapters" v-else-if="$store.getters.chapterEntryMode === 'timeshift'"></ChapterEntryListInTimeShiftMode>
            </div>
        </div>

        <!-- Sidepanel -->
        <div class="col-12 col-lg-5 h-inherit">
            <div class="row no-gutters h-inherit">
                <div class="col-12 h-49 overflow-auto position-relative">
                    <SidePanelCard position="top"></SidePanelCard>
                </div>

                <div class="col-12 h-49 overflow-auto position-relative">
                    <SidePanelCard position="bottom"></SidePanelCard>
                </div>

                <div class="col-12 copyright">
                    &copy; {{ currentYear }} by Niche Guardian. Designed by Kirepo.lu
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VideoContainer from './chaptering/SidePanel/panels/VideoContainer';
import SidePanelCard from './chaptering/SidePanel/SidePanelCard';

import { RepositoryFactory } from '../../repositories/RepositoryFactory';

import DefaultChapterEntryList from './chaptering/Chapters/List/DefaultMode/DefaultChapterEntryList';
import ChapterEntryListInMoveMode from './chaptering/Chapters/List/MoveMode/ChapterEntryListInMoveMode';
import ChapterEntryListInTimeShiftMode from './chaptering/Chapters/List/TimeShiftMode/ChapterEntryListInTimeShiftMode';
import ChapterEntryListInReadOnlyMode from './chaptering/Chapters/List/ReadOnlyMode/ChapterEntryListInReadOnlyMode';

const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'InstanceManagement',
  components: {
	  ChapterEntryListInReadOnlyMode,
    ChapterEntryListInTimeShiftMode, DefaultChapterEntryList, ChapterEntryListInMoveMode, SidePanelCard, VideoContainer,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
	      liveInterval: null,
	      activeRefreshInterval: null,
    };
  },
  beforeDestroy() {
    	/*
    	    Destroy running intervals.
    	 */
	    clearInterval(this.liveInterval);
    	this.liveInterval = null;

	    clearInterval(this.activeRefreshInterval);
    	this.activeRefreshInterval = null;
  },
  methods: {
  	refreshLiveSecondsTimer() {
  		const vm = this;
		  // Refresh the Live Timestamp
		  clearInterval(this.liveInterval);
		  this.liveInterval = null;
		  this.liveInterval = setInterval(() => {
			  const elapsedSeconds = vm.$store.getters.getInstanceLiveElapsedSeconds;
			  if (elapsedSeconds !== null) {
				  vm.$store.commit('updateInstanceLiveSeconds', elapsedSeconds + 1);
			  }
		  }, 1000);
    }
  },
  created() {
    const vm = this;

    // Set the Active Tab
	  if (this.$store.getters.instanceLoaded) {
		  if(!this.$store.getters.instanceInReadOnly) {
			  if (this.$store.getters.instanceInLiveMode) {
				  this.$store.commit('setActiveSidePanelTab', { position: 'top', tab: 'livestream' });
			  } else {
				  this.$store.commit('setActiveSidePanelTab', { position: 'top', tab: 'video' });
			  }
			  this.$store.commit('setActiveSidePanelTab', { position: 'bottom', tab: 'memberlist' });
		  }
	  }

	  this.refreshLiveSecondsTimer();

	  // Refresh the Active Instance
    this.activeRefreshInterval = setInterval(() => {
      if (vm.$store.getters.instanceLoaded) {
        InstanceRepository.refetchActive(false).catch(error => {
          vm.$snotify.error("Unable to reload Instance Data. Please try again later. you might not be able to make changes.");
        }).then(res => {
	        this.refreshLiveSecondsTimer();
        });
      }
    }, 10000);
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    chapters() {
      if (this.instance !== null) return this.instance.chapters;
      return null;
    },
  },
};
</script>

<style>
    .h-49 {
        height: 49% !important;
    }
    .copyright {
        height: 2% !important;
        background-color: #343A40;
        line-height: 2%;
        color: white;
        font-style: italic;
        text-align: center;
        padding-top: 9px;
        overflow: hidden;
    }
</style>
